import { useState } from "react";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { PhoneInput } from "./PhoneInput";
import { useBT } from "./i18n";
import { Loader2 } from "lucide-react";

export const GuestForm = ({ onSubmit, submitting, submitLabel }) => {
  const { t } = useBT();
  const [f, setF] = useState({ name: "", email: "", cc: "+30", phone: "", guests: 2, notes: "", consent: false });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = (e) => {
    e.preventDefault();
    onSubmit({ name: f.name, email: f.email, phone: `${f.cc} ${f.phone}`, guests: Number(f.guests), notes: f.notes });
  };

  return (
    <form onSubmit={submit} className="bg-white border rounded-xl p-6 grid sm:grid-cols-2 gap-5" data-testid="book-step-details">
      <div className="sm:col-span-2">
        <Label htmlFor="bk-name">{t.name}</Label>
        <Input id="bk-name" required minLength={2} value={f.name} onChange={set("name")} data-testid="book-input-name" />
      </div>
      <div>
        <Label htmlFor="bk-email">{t.email}</Label>
        <Input id="bk-email" type="email" required value={f.email} onChange={set("email")} data-testid="book-input-email" />
      </div>
      <div>
        <Label htmlFor="bk-phone">{t.phone}</Label>
        <PhoneInput id="bk-phone" cc={f.cc} phone={f.phone} onCc={set("cc")} onPhone={set("phone")} testid="book-input" />
      </div>
      <div>
        <Label htmlFor="bk-guests">{t.guests}</Label>
        <Input id="bk-guests" type="number" min={1} max={30} required value={f.guests} onChange={set("guests")} data-testid="book-input-guests" />
      </div>
      <div className="sm:col-span-2">
        <Label htmlFor="bk-notes">{t.notes}</Label>
        <Textarea id="bk-notes" maxLength={1000} value={f.notes} onChange={set("notes")} data-testid="book-input-notes" placeholder={t.notesPh} />
      </div>
      <label className="sm:col-span-2 flex items-start gap-2 text-xs text-[#1d2b31]/70">
        <input type="checkbox" required checked={f.consent} onChange={set("consent")} data-testid="book-input-consent" className="mt-0.5" />
        {t.consent}
      </label>
      <button type="submit" disabled={submitting} data-testid="book-submit"
        className="sm:col-span-2 inline-flex justify-center items-center gap-2 bg-[#15262d] text-white text-xs uppercase tracking-[0.2em] px-6 py-4 rounded-sm hover:bg-[#b09873] transition-colors disabled:opacity-60">
        {submitting && <Loader2 size={14} className="animate-spin" />} {submitLabel || t.confirm}
      </button>
    </form>
  );
};
